import React from 'react';
import './Modal.css';

export default function Modal({ open, onClose, children }) {
  if (!open) return null;
  return (
    <div className="bp-modal-backdrop" onClick={onClose}>
      <div className="bp-modal" onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
}
